import clsx from 'clsx';
import { array, bool, func, node, oneOfType, string } from 'prop-types';
import { Fragment } from 'react';

import { FormRadio } from 'components';

const RadioGroup = ({
  radioOptions,
  groupLabel = '',
  labelHidden = false,
  className = '',
  row = false,
  /**
   * Value of the radio option that allow to display the slot
   */
  showSlot = null,
  /**
   * Function that return the content to display under radio option
   */
  slot = null,
  ...props
}) => {
  const legendId = `radio-legend-${Math.floor(Math.random() * 1000)}`;

  return (
    <div
      className={clsx('radio-group gap-4 lg:gap-6 flex', !row && 'flex-col', className)}
      role="group"
      aria-labelledby={legendId}
    >
      <div
        id={legendId}
        className={clsx(
          'legend uppercase col-span-4',
          row ? 'mb-0' : 'mb-6',
          props.readOnly && 'disabled',
          labelHidden && 'sr-only'
        )}
      >
        {groupLabel}
      </div>
      {radioOptions.map((option) => (
        <Fragment key={option.uuid}>
          <FormRadio {...option} {...props} />

          {option.value === showSlot && slot && slot()}
        </Fragment>
      ))}
    </div>
  );
};

RadioGroup.propTypes = {
  radioOptions: array.isRequired,
  groupLabel: oneOfType([string, node]),
  labelHidden: bool,
  readOnly: bool,
  disabled: bool,
  row: bool,
  className: string,
  showSlot: string,
  slot: func
};

export default RadioGroup;
